import { DecimalPipe } from '@angular/common';
import { PATTERN } from 'src/app/constants/pattern';
import { GENERAL_CONSTANTS, VALID_IMG_FORMATS, WALLET_COUNTRY_CODES } from 'src/app/core/constants/General-constants';

export class GeneralTool {
  /**
   *
   * @description {formatNumber} Function to add decimals, tens and hundreds to the values of the order
   * @param inputValue
   * @returns format value
   */
  static formatNumber(inputValue: string) {
    const decimalPipe = new DecimalPipe('en-US');

    return !isNaN(Number(inputValue)) ? decimalPipe.transform(Number(inputValue), '1.2-2') : '';
  }

  /**
   *
   * @description {validateDecimal} Function to check if it is a decimal number
   * @param firstValue first payvalue
   * @param secondValue second payvalue
   * @returns boolean
   */
  static validateDecimal(paymentValue: number) {
    if (paymentValue) return !isNaN(paymentValue) && paymentValue.toString().indexOf('.') !== -1;
  }

  /**
   *
   * @description {validateUrlProtocol} Function to validate url protocol https
   * @param url to validate
   * @returns boolean
   */
  static validateUrlProtocol(url: string) {
    return url && url.startsWith('https');
  }

  static checkMerchantHasWallet(data) {
    if (data.CODE === GENERAL_CONSTANTS.OK_RESPONSE_CODE) {
      const walletCountryCodes = Object.values(WALLET_COUNTRY_CODES);

      for (const element of data.DATA.paymentMethods) {
        if (walletCountryCodes.includes(element.originCode)) return true;
      }
    }

    return false;
  }

  /**
   *
   * @description Function that validates if the images have a valid format
   * @param str string to validate
   * @returns boolean
   */
  static itsValidImage(str: string) {
    try {
      const regex = PATTERN.REGEX_FORMAT_IMG;
      const match = regex.exec(str);

      if (match && match?.length > 1) {
        const extension = match[1]?.toLowerCase();

        return VALID_IMG_FORMATS.includes(extension);
      }

      return false;
    } catch (_) {
      return false;
    }
  }
}
